(function ($) {
  var elementorHookRegistered = false;
  var openerSelector = '[data-accordeon-opener], [data-opener-accordeon]';
  var drawerSelector = '[data-accordeon-drawer], [data-drawer-accordeon]';
  var listingFormationsBreakpoint = window.matchMedia('(max-width: 1023.98px)');
  var widgetSelector = [
    '.elementor-widget-accordeon',
    '.elementor-widget-grille-de-cours',
    '.elementor-widget-listing-formations'
  ].join(', ');

  function getAccordionRoot($trigger) {
    var $root = $trigger.closest('.accordeon, .container-terms');

    return $root.length ? $root : $trigger.parent();
  }

  function initAccordeonCommon($scope) {
    var $openers = $scope.find(openerSelector);

    if (!$openers.length) {
      return;
    }

    $openers.off('click.accordeonCommon').on('click.accordeonCommon', function () {
      var $trigger = $(this);
      var $currentAccordion = getAccordionRoot($trigger);
      var $currentDrawer = $currentAccordion.find(drawerSelector).first();
      var isFilter = $trigger.closest('.container-terms').length > 0;
      var shouldCloseOtherDrawers = !isFilter || listingFormationsBreakpoint.matches;

      if (!$currentDrawer.length) {
        return;
      }

      if (shouldCloseOtherDrawers) {
        $scope.find(drawerSelector).not($currentDrawer).stop(true, true).slideUp();
        $scope.find(openerSelector).not($trigger).removeClass('active');
      }

      if ($currentDrawer.is(':visible')) {
        $currentDrawer.stop(true, true).slideUp();
        $trigger.removeClass('active');
      } else {
        $currentDrawer.stop(true, true).slideDown();
        $trigger.addClass('active');
      }
    });

    closeListingFormationsFilters($scope);
  }

  function closeListingFormationsFilters($scope) {
    if (
      !listingFormationsBreakpoint.matches ||
      !$scope.hasClass('elementor-widget-listing-formations')
    ) {
      return;
    }

    $scope.find('aside ' + openerSelector).removeClass('active');
    $scope.find('aside ' + drawerSelector).hide();
  }

  function closeAllListingFormationsFilters() {
    $('.elementor-widget-listing-formations').each(function () {
      closeListingFormationsFilters($(this));
    });
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;

    [
      'accordeon',
      'grille-de-cours',
      'listing-formations'
    ].forEach(function (widgetName) {
      window.elementorFrontend.hooks.addAction(
        'frontend/element_ready/' + widgetName + '.default',
        initAccordeonCommon
      );
    });
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();

    $(widgetSelector).each(function () {
      initAccordeonCommon($(this));
    });

    if (listingFormationsBreakpoint.addEventListener) {
      listingFormationsBreakpoint.addEventListener('change', closeAllListingFormationsFilters);
    } else if (listingFormationsBreakpoint.addListener) {
      listingFormationsBreakpoint.addListener(closeAllListingFormationsFilters);
    }
  });
})(jQuery);
